import fonts from 'styles/fonts';
import parseHEX from 'styles/helpers/colors/parseHEX';
import styled from '@emotion/styled';
import { Theme } from 'widget/styles/themes';

type Props = {
  'data-test'?: string;
  cursorPointer?: boolean;
  thinRow?: boolean;
};

const Row = styled('div')<Props>(({
  cursorPointer = true,
  theme,
  thinRow,
}: {
  cursorPointer?: boolean;
  theme: Theme;
  thinRow?: boolean;
}) => {
  const { r, g, b } = parseHEX(theme.backgroundSecondary!);

  return {
    ':hover': {
      backgroundColor: cursorPointer ? `rgba(${r}, ${g}, ${b}, 0.5)` : 'auto',
    },
    cursor: cursorPointer ? 'pointer' : 'auto',
    fontSize: fonts.size['12'],
    overflow: 'auto',
    padding: thinRow ? '0.5rem 1.3rem' : '1rem',
  };
});

export default Row;
